import {
  LastOnlineDispatchTypes,
  LAST_ONLINE_LOADING,
  LAST_ONLINE_FAILURE,
  LAST_ONLINE_SUCCESS,
  LastOnlineEntry,
} from "../actions/lastOnlineActionTypes";

interface LastOnlineState {
  loading: boolean;
  lastOnline?: LastOnlineEntry[];
  hasData?: boolean;
}

const defaultState: LastOnlineState = {
  loading: false,
};

const lastOnlineReducer = (
  state: LastOnlineState = defaultState,
  action: LastOnlineDispatchTypes
): LastOnlineState => {
  switch (action.type) {
    case LAST_ONLINE_LOADING:
      return { ...state, loading: true };
    case LAST_ONLINE_FAILURE:
      return { ...state, loading: false, hasData: false };
    case LAST_ONLINE_SUCCESS:
      return { loading: false, lastOnline: action.payload, hasData: true };
    default:
      return state;
  }
};

export default lastOnlineReducer;
